import { render } from "./SidebarList.vue?vue&type=template&id=67b0657e&bindings={}"
import script from "./SidebarList.vue?vue&type=script&lang=ts"
export * from "./SidebarList.vue?vue&type=script&lang=ts"

import "./SidebarList.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script